var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "edit-video-course" }, [
    _c("div", { staticClass: "edit-video-course__body container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            {
              staticClass:
                "edit-video-course__header-title typography--color-primary text-center"
            },
            [
              _vm.course
                ? _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("publishers.modal.edit_video_course.title")
                        ) +
                        "\n          "
                    )
                  ])
                : _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("publishers.modal.new_video_course.title")
                        ) +
                        "\n          "
                    )
                  ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "edit-video-course__form" }, [
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "subject-select" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("publishers.modal.new_series.subject")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.subjectId,
                      expression: "subjectId"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "subject-select" },
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.subjectId = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.onSubjectSelect
                    ]
                  }
                },
                [
                  _c("option", { attrs: { disabled: "", value: "" } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t(
                            "publishers.modal.new_series.subject_placeholder"
                          )
                        ) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(
                    _vm.subjectIds.filter(function(id) {
                      return id !== "0" && id !== "9999"
                    }),
                    function(sjId) {
                      return _c(
                        "option",
                        { key: sjId, domProps: { value: sjId } },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.getTranslatedName(_vm.subjectMap[sjId])
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    }
                  )
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "grade-select" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("publishers.modal.new_series.grade")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.gradeId,
                      expression: "gradeId"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "grade-select" },
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.gradeId = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.onGradeSelect
                    ]
                  }
                },
                [
                  _c("option", { attrs: { disabled: "", value: "" } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t(
                            "publishers.modal.new_series.grade_placeholder"
                          )
                        ) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(
                    _vm.gradeIds.filter(function(id) {
                      return id !== "0" && id !== "9999"
                    }),
                    function(gId) {
                      return _c(
                        "option",
                        { key: gId, domProps: { value: gId } },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.getTranslatedName(_vm.gradeMap[gId])) +
                              "\n              "
                          )
                        ]
                      )
                    }
                  )
                ],
                2
              )
            ]),
            _vm._v(" "),
            _vm.isCoreConcepts
              ? _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass:
                        "typography--body-3 typography--color-secondary typography--font-weight-600",
                      attrs: { for: "core-concept-select" }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t("card_details.card_meta.core_concept")
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.coreConceptId,
                          expression: "coreConceptId"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { id: "core-concept-select" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.coreConceptId = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { disabled: "", value: "" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t(
                                "card_details.card_meta.core_concepts_placeholder"
                              )
                            ) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.coreConcepts, function(coreConcept) {
                        return _c(
                          "option",
                          {
                            key: coreConcept.id,
                            domProps: { value: coreConcept.id }
                          },
                          [
                            _vm._v(
                              "\n                [" +
                                _vm._s(coreConcept.id) +
                                "] " +
                                _vm._s(coreConcept.name) +
                                " | " +
                                _vm._s(coreConcept.code) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "video-course-title-input" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("publishers.modal.new_series.name")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.courseTitle,
                    expression: "courseTitle",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "video-course-title-input",
                  maxlength: "40",
                  placeholder: _vm.$t(
                    "publishers.modal.new_series.name_placeholder"
                  )
                },
                domProps: { value: _vm.courseTitle },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.courseTitle = $event.target.value.trim()
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "video-course-description-input" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.$t("publishers.modal.new_series.description")
                      ) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.courseDescription,
                    expression: "courseDescription"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  id: "video-course-description-input",
                  rows: "5",
                  maxlength: "500",
                  placeholder: _vm.$t(
                    "publishers.modal.new_series.description_placeholder"
                  )
                },
                domProps: { value: _vm.courseDescription },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.courseDescription = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _vm.course
              ? _c("div", { staticClass: "text-center mt-2" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-primary btn-full edit-video-course__create-btn",
                      attrs: { disabled: _vm.newCourseDisabled },
                      on: {
                        click: function($event) {
                          return _vm.update()
                        }
                      }
                    },
                    [
                      !_vm.busy
                        ? _c("span", [_vm._v(_vm._s(_vm.$t("common.save")))])
                        : _c("LoadingBounce")
                    ],
                    1
                  )
                ])
              : _c("div", { staticClass: "text-center mt-2" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-primary btn-full edit-video-course__create-btn",
                      attrs: { disabled: _vm.newCourseDisabled },
                      on: {
                        click: function($event) {
                          return _vm.create()
                        }
                      }
                    },
                    [
                      !_vm.busy
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("video_lectures.new_video_course.create")
                              )
                            )
                          ])
                        : _c("LoadingBounce")
                    ],
                    1
                  )
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-center mt-2" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-secondary btn-full edit-video-course__cancel-btn typography--color-secondary",
                  on: {
                    click: function($event) {
                      return _vm.prevLink()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("btn.redirect_to_root")) +
                      "\n            "
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-164adeab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-164adeab","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/video-courses/views/EditVideoCourse.vue
// module id = SqUV
// module chunks = 1